/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {ViewEncapsulation, Component, Input, Output, EventEmitter} from '@angular/core';


/**
 * Fc AG Toggle button component.
 */
@Component({
    selector: 'fc-ag-toggle-button',
    templateUrl: './fc-ag-toggle-button.html',
    styleUrls: ['./fc-ag-toggle-button.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcAgToggleButtonComponent {
    /**
     * Toggle value.
     */
    @Input()
    toggleValue: boolean = false;

    /**
     * Output Trigger Toggle Value Changed event.
     * Pair with Two-Way binding.
     */
    @Output() toggleValueChange: EventEmitter<boolean>;

    /**
     * Toggle label.
     */
    @Input()
    toggleLabel?: string = '';


    /**
     * Show current boolean value.
     */
    @Input()
    showCurrentToggleValue?: boolean = true;
    
    
    /**
     * Component constructor.
     */
    constructor() {
        this.toggleValueChange = new EventEmitter<boolean>();
    }

    /**
     * Toggle button function.
     */
    toggleButtonValue() {
        this.toggleValue = !this.toggleValue;
        this.toggleValueChange.emit(this.toggleValue);
    }
}
